module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.17592/js/img/valuePropModals/SequencesEmailCommunicator/ValueProp2.svg"